import React from 'react';
import { useNetwork } from '../context/NetworkContext';
import { WifiOff } from 'lucide-react';

export function OfflineBanner() {
  const { online } = useNetwork();

  if (online) return null;

  return (
    <div
      data-testid="offline-banner"
      className="fixed top-0 left-0 right-0 z-[100] bg-destructive text-destructive-foreground px-4 py-2 flex items-center justify-center gap-2 text-sm font-medium shadow-md"
    >
      <WifiOff className="h-4 w-4 shrink-0" />
      <span>You're offline. Some features require internet.</span>
    </div>
  );
}


